import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

@Component({
  selector: 'app-project-health',
  templateUrl: './project-health.component.html',
  styleUrls: ['./project-health.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectHealthComponent implements OnInit {
  @Input() aggregateValues: any;
  @Input() projectTypes: any;
  @Input() filterType: any;

  @Output() changeProjectType = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }

  changeType(type: any) {
    this.changeProjectType.emit(type);
  }

}
